import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import PodcastBase from 'components/Pages/ArticleParts/PodcastBase';
import useHelpers from 'hooks/helpers';

type Props = ComponentProps & {
  fields: {
    url: {
      value: string;
    };
    title: {
      value: string;
    };
  };
};

const SpotifyPodcast = ({ fields, rendering }: Props): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  return (
    <PodcastBase id={anchorId} fields={fields}>
      <iframe
        className="iframe"
        style={{ display: 'block', borderRadius: '12px' }}
        src={fields.url?.value}
        width="100%"
        height="152"
        allowFullScreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        title={fields.title?.value}
      />
    </PodcastBase>
  );
};

export default withDatasourceCheck()(SpotifyPodcast);
